import Grid from "@mui/material/Grid";
import {Item} from "../CharStyled";
import React from "react";
import {displaySchwelleWithMod} from "../../_helper/displaySchwelleWithMod";
import {useSignals} from "@preact/signals-react/runtime";

export default function CharBEW() {
    useSignals()
    return <Grid item sm={2} xs={4}>
        <Item>
            <div>Bewußtl.schw:</div>
            {displaySchwelleWithMod("bs")}
        </Item>
    </Grid>
}